export default __webpack_public_path__ + "assets/fc10ccf11a61bac919b98aba11c990eb.ttf";